import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Award, Sparkles } from 'lucide-react';
import DistributorCard from '../../../components/common/distributorCard/DistributorCard';
import '../../../assets/styles/customer/layout/FeaturedDistributorsSection.css';

const FeaturedDistributorsSection = () => {
  const featuredDistributors = [
    {
      id: 1,
      name: 'Ahmad Dairy Farm',
      image: 'https://images.unsplash.com/photo-1563636619-e9143da7973b?w=600&q=80',
      rating: 4.9,
      description: 'Premium quality milk delivered fresh to your doorstep every morning with care',
      location: 'Karachi, Pakistan',
      price: '185',
      deliveries: '1.2K',
      customers: '450+'
    },
    {
      id: 2,
      name: 'Green Valley Milk',
      image: 'https://images.unsplash.com/photo-1628088062854-d1870b4553da?w=600&q=80',
      rating: 4.8,
      description: 'Farm-fresh organic milk from grass-fed cows delivered daily',
      location: 'Lahore, Pakistan',
      price: '175',
      deliveries: '980',
      customers: '380+'
    },
    {
      id: 3,
      name: 'Pure Farm Dairy',
      image: 'https://images.unsplash.com/photo-1550583724-b2692b85b150?w=600&q=80',
      rating: 4.9,
      description: 'Pure and hygienic milk from healthy cows with guaranteed freshness',
      location: 'Faisalabad, Pakistan',
      price: '180',
      deliveries: '1.5K',
      customers: '520+'
    },
    {
      id: 4,
      name: 'Mountain Fresh',
      image: 'https://images.unsplash.com/photo-1600788907416-456578634209?w=600&q=80',
      rating: 4.7,
      description: 'Pure mountain milk from healthy, happy cows in natural environment',
      location: 'Islamabad, Pakistan',
      price: '190',
      deliveries: '850',
      customers: '320+'
    }
  ];

  return (
    <section className="featured-distributors-section">
      
      {/* Floating Elements */}
      <div className="featured-floating-elements">
        <div className="featured-circle circle-1"></div>
        <div className="featured-circle circle-2"></div>
        <div className="featured-milk milk-1">🥛</div>
        <div className="featured-milk milk-2">🥛</div>
      </div>

      {/* Wavy Background */}
      <div className="featured-wave-bg">
        <svg className="featured-wave" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="rgba(62, 150, 231, 0.04)" 
            d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,165.3C1248,171,1344,149,1392,138.7L1440,128L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          ></path>
        </svg>
      </div>

      <Container>
        
        {/* Section Header */}
        <div className="featured-header text-center">
          <div className="featured-badge">
            <Award size={18} />
            <span>Featured Distributors</span>
          </div>
          <h2 className="featured-title">
            Top-rated distributors with premium quality milk
          </h2>
        </div>

        {/* Distributors Grid */}
        <Row className="g-4 featured-grid">
          {featuredDistributors.map((distributor, index) => (
            <Col lg={3} md={6} sm={6} xs={12} key={distributor.id}>
              <div 
                className="featured-card-wrapper"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <DistributorCard distributor={distributor} featured={true} />
              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default FeaturedDistributorsSection;